<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("concessionstock") }}</div>
      </div>
      <!-- <div>
        <b-button variant="default" to="add-concession-stock" class="btn-blue">{{ $tc('add') }}</b-button>
      </div>-->
    </div>
    <br />

    <div
      v-if="selectedCinema != ''"
      class="d-flex justify-content-between align-items-center my-3"
    >
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2">
          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              {{ $tc("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;{{ $tc("of") }}&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
        <!-- <button
          class="btnj btn-gridView mr-3"
          :class="gridView ? 'active':''"
          v-on:click="viewType('gridView')"
        ></button>-->
        <!-- <button
          class="btnj btn-listView"
          :class="listView ? 'active':''"
          v-on:click="viewType('listView')"
        ></button>-->
      </div>
    </div>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-for="(cs, csKey) in concession_stocks"
        :key="csKey"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ cs.cl_name }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  @click="goToRoute('/fnb/edit-concession-stock', cs)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <!-- <b-dropdown-item @click="goToRoute('/fnb/view-concession-stock',cs)">
                  <span class="icon-eye mr-1"></span>
                  {{ $t('view') }}
                </b-dropdown-item>-->
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1">
              <div class="count">059</div>
              <div class="text">
                No of
                <br />employees
              </div>
            </div>
            <!-- <div class="d-flex align-items-end">
              <label class="ios-switch">
                <input
                  :checked="cs.fw_is_active == 'Y' ? true: false"
                  type="checkbox"
                  class="ios-checkbox"
                />
                <span class="switch-slider"></span>
              </label>
            </div>-->
          </div>
        </div>
      </div>
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-md-4 mb-4">
          <div class="dropdown-curve-container">
            <label :class="selectedCinema.length > 0 ? 'shift-up' : ''">{{
              $tc("cinema", 1)
            }}</label>
            <div class>
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <!-- _getCountryList(item.label, null) -->
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    :placeholder="$tc('Search Cinema')"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in cinemaList"
                  :key="dropdownIndex"
                  href="#"
                  @click="onDropdownChange($event, dropdownItem)"
                  >{{ dropdownItem.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-4">
          <div class="dropdown-curve-container">
            <label :class="selectedStore.length > 0 ? 'shift-up' : ''">{{
              $tc("store", 1)
            }}</label>
            <div class>
              <b-dropdown
                :text="selectedStore"
                variant="dropdown-curve"
                class="w-100"
              >
                <!-- _getCountryList(item.label, null) -->
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in storeLevels"
                  :key="dropdownIndex"
                  href="#"
                  @click="onSelectStore(dropdownItem)"
                  >{{ dropdownItem.sm_store_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-4">
          <div class>
            <multiselect
              v-model="selected_category"
              :options="ms_raw_material_categories"
              label="rmc_category"
              track-by="rmc_id"
              @select="onSelectCategory"
              :placeholder="$t('Select Category')"
            ></multiselect>
          </div>
        </div>
      </div>
      <!-- LIST VIEW DESIGNATION -->

      <table class="list-view-table" v-if="listView">
        <thead>
          <tr>
            <th>{{ $t("Raw Materials Code") }}</th>
            <th>
              <img
                v-if="this.columnName != 'rm_name'"
                @click="onSortValue('rm_name', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('rm_name', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('rm_name', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $tc("rawmaterials", 2) }}
            </th>
            <th class="mr-2">Minimum {{ $tc("stock") }} {{ $tc("Value", 2) }}</th>
            <th class="mr-2">{{ $tc("System") }} {{ $tc("stock", 2) }}</th>
            <th >{{ $tc("Consumption") }} {{ $tc("Unit", 2) }}</th>
            <th>{{ $tc("Remaining Thresold") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(cs, csKey) in concession_stocks" :key="csKey">
            <td>{{ cs.rm_code }}</td>
            <td>{{ cs.rm_name }}</td>
            <td class="text-left">{{ cs.stock_alert_quantity_threshold }}</td>

            <td
              class="text-left"
              v-if="
                cs.uom_unit == 'Each' ||
                  cs.uom_unit == 'Packet' ||
                  cs.uom_unit == 'Bottle'
              "
            >
              {{ parseFloat(cs.final_stock_quantity) }} {{ cs.uom_unit }}
            </td>
            <td class="text-left" v-else>
              {{ parseFloat(cs.final_stock_quantity) }}
              {{ cs.uom_unit }}
            </td>
            <td class="text-left">
              {{ parseFloat(cs.stock_quantity_consumed_new) || 0 }}
              {{ cs.uom_unit }}
            </td>
            <td class="text-left">
              {{
                parseFloat(cs.final_stock_quantity) -
                  parseFloat(cs.stock_alert_quantity_threshold)
              }}

              {{ cs.uom_unit }}
            </td>

            <!-- <td>{{ wasteKey.fp_total_amount }}</td>
          <td>{{ wasteKey.fp_from_date | dateparse}}</td>
            <td>{{ wasteKey.fp_to_date | dateparse}}</td>-->
            <!-- <td>
              <div class="d-flex align-items-center justify-content-end">
                <b-dropdown right variant="edit" class="ml-4">
                  <b-dropdown-item @click="goToRoute('/fnb/edit-concession-stock',cs)">
                    <span class="edit-pen"></span>
                    {{ $t('edit') }}
                  </b-dropdown-item>
                  <b-dropdown-item @click="goToRoute('/fnb/view-concession-stock',cs)">
                  <span class="icon-eye mr-1"></span>
                  {{ $t('view') }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td>-->
          </tr>
          <tr v-if="concession_stocks.length == 0">
            <!-- <h6 class="ml-3">
              No Records Found
              <br />Please select Cinema
            </h6> -->
            <td colspan="3">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
      <div
        v-if="concession_stocks.length > 0"
        class="d-flex justify-content-end align-items-center"
      >
        Download
        <img
          @click="excelDownload()"
          src="@/assets/img/icons/excel.svg"
          height="25"
          width="25"
        />
      </div>
    </div>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
import NoRecords from "@/components/Partials/NoRecords.vue";
import xlsx from "json-as-xlsx";
export default {
  components: {
    NoRecords
  },
  data() {
    return {
      cinemaListCopy: [],
      searchCinema: "",
      isRoleID: true,
      isRoleID1: null,
      getitem: "",
      perPage: 10,
      perPageExcel: 100000,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      selectedid: "",

      gridView: false,
      listView: true,
      concession_stocks: [],
      concession_stocks_excel: [],
      cinemaList: [],
      selectedStore: "",
      storeLevels: [],
      cinema_id: "",
      selectedCinema: "",
      selected_store_id: "",

      //sorting
      isSort: false,
      isAscending: false,
      columnName: "",
      orderBy: "",
      ms_raw_material_categories: [],
      selected_category: ""
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    this.isRoleID1 = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
      this.getCinemaList(obj);
    } else {
      this.getCinemaList(obj);
    }
    this.getviewingnumber();
    this.getStoreStockExcel();
    this.getRawMaterialCategories();
  },
  mounted() {},
  methods: {
    onSelectCategory(event) {
      this.selected_category = event;
      this.currentPage = 1;
      this.perPage = 10;
      this.getStoreStock();
    },
    getRawMaterialCategories: function() {
      this.ms_raw_material_categories = [];

      // limit=10&currentPage=1&searchKey=rmc_category&filter_is_active=Y
      let payload = {
        limit: 10000,
        currentPage: 1,
        searchValue: null,
        searchKey: "rmc_category",
        filter_is_active: "Y"
      };
      PosFnbService.GetRawMaterialCategories(payload)
        .then(response => {
          const { data } = response;
          //console.log("data.message :", data.message);
          if (data && data.status && data.Records.length > 0) {
            this.ms_raw_material_categories = data.Records;
          } else {
            this.$toasted.show("No Records Found");
          }
        })
        .catch(this._CatchError); //message
    },
    excelDownload() {
      let temp_data = this.concession_stocks_excel;

      let dateparse = function(value) {
        if (!value) return "-";
        else if (value === "Invalid date") return "-";
        else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid())
          return value
            ? moment(value, "DD-MM-YYYY HH:mm").format("DD-MMM-YYYY")
            : "-";
        //else return value ? moment(value).format('DD-MM-YYYY') === 'Invalid date' ? '-' : moment(value).format('DD-MM-YYYY') : '-';
        //this is changed acc to mams decision
        else
          return value
            ? moment(value).format("DD-MM-YYYY") === "Invalid date"
              ? "-"
              : moment(value).format("DD-MMM-YYYY")
            : "-";
      };
      let fulldatemonparse = function(value) {
        if (!value) return "-";
        else if (value === "Invalid date") return "-";
        else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid())
          return value
            ? moment(value, "DD-MM-YYYY HH:mm").format("DD-MMM-YYYY HH:mm")
            : "-";
        //else return value ? moment(value).format('DD-MM-YYYY') === 'Invalid date' ? '-' : moment(value).format('DD-MM-YYYY') : '-';
        //this is changed acc to mams decision
        else
          return value
            ? moment(value).format("DD-MM-YYYY") === "Invalid date"
              ? "-"
              : moment(value).format("DD-MMM-YYYY HH:mm")
            : "-";
      };

      let data = [
        {
          sheet: "Concession Stock",

          columns: [
            {
              value: "cinema_name",
              label: "Cinema Name"
            },
            {
              value: "store_name",
              label: "Store"
            },
            {
              value: "rm_code",
              label: "Raw Material Code"
            },
            {
              value: "rm_name",
              label: "Raw Material"
            },
            {
              value: row =>
                row.final_stock_quantity
                  ? +parseFloat(row.final_stock_quantity).toFixed(2)
                  : "-",
              label: "Stock Quantity"
            },
            {
              value: "uom_unit",
              label: "UOM"
            }

            //      Sold: 0,
            // gross_amount: 0,
            // offer_price: 0,
            // total_taxes: 0,
            // final_gross_amount: 0
          ],
          content: temp_data
        }
      ];
      let settings = {
        fileName: `ConcessionStock${new Date().getTime()}`
      };
      xlsx(data, settings);
    },
    onSortValue(columnName, orderBy) {
      if (this.selectedid.length == 0) {
        return this.$toasted.show("Please select store");
      }
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderBy = orderBy;
      this.getStoreStock(this.selectedid);
    },
    onSearchCinema: function() {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.cinemaList = this.cinemaListCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.cinemaList = this.cinemaListCopy;
      }
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },
    /* eslint-disable */
    onChangePagination: function(event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getStoreStock(this.selectedid);
      } else if (this.isRoleID1 == 1 || this.isRoleID1 == 2) {
        this.currentPage = event;
        this.getStoreStock(this.selectedid);
      } else {
        this.currentPage = event;
        this.getStoreStock(this.getitem);
      }
    },
    getCinemaList: function(cine_id) {
      // let payload = {
      //   tableName: "ms_cinemas",
      //   cine_is_active: "Y"
      // };
      // MasterService.GlobalRequest(body)
      MasterService.GetCinemas({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            console.log("data :", data);
            this.cinemaList = data.Records;
            this.cinemaListCopy = data.Records;
            this.cinemaList.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                // this.selectedCinema = x.cine_name;
                // this.getitem = x.cine_id;
                // this.getConcessionStocks(this.getitem);
                this.onDropdownChange(null, x);
              }
            });
            this.rows = data.totalRows;
          } else {
            //  Show Error Message
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          console.log("Catch Error On getCinemaList :", error);
        });
    },
    onDropdownChange: function(event, item) {
      this.selectedCinema = item.cine_name;
      this.selectedid = item.cine_id;
      this.searchCinema = "";
      this.onSearchCinema();
      this.getStoreManagement(item.cine_id);
      // this.getConcessionStocks(item.cine_id);
    },
    getStoreManagement(cinema_id) {
      this.storeLevels = [];
      this.selectedStore = "";
      // let payload = {
      //   tableName: "store_management",
      //   sm_is_active: "Y",
      //   cinema_id: cinema_id
      // };
      MasterService.GetStoreManagement({ cine_id: cinema_id })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.storeLevels = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    onSelectStore: function(store) {
      this.selectedStore = store.sm_store_name;
      this.selected_store_id = store.sm_id;
      this.getStoreStock(this.selectedid);
    },
    getStoreStockExcel: function(cinema_id) {
      this.concession_stocks_excel = [];
      let payload = {
        limit: this.perPageExcel,
        currentPage: 1,
        searchValue: "",
        columnName: "",
        orderBy: "",
        cinema_id: this.selectedid || cinema_id,
        store_id: this.selected_store_id,
        rmc_id: this.selected_category ? this.selected_category.rmc_id : null
      };
      PosFnbService.GetAllStoreStock(payload)
        .then(response => {
          const { data } = response;

          this.concession_stocks_excel = data.Records;
          // if (data.totalRows >= 10) {
          //   this.rows = data.totalRows;
          // } else {
          //   this.rows = data.totalRows;
          //   this.selectedvalue = data.totalRows;
          // }

          this.concession_stocks_excel.forEach(x => {
            x["cinema_name"] = this.selectedCinema;
            x["store_name"] = this.selectedStore;
          });
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    getStoreStock: function(cinema_id) {
      this.concession_stocks = [];
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        cinema_id: this.selectedid || cinema_id,
        store_id: this.selected_store_id,
        columnName: this.columnName,
        orderBy: this.orderBy,
        rmc_id: this.selected_category ? this.selected_category.rmc_id : null
      };
      PosFnbService.GetAllStoreStock(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.concession_stocks = data.Records;
            this.getStoreStockExcel();
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
              if (parseInt(this.perPage) > data.totalRows) {
                this.selectedvalue = data.totalRows;
              } else {
                this.selectedvalue = this.perPage;
              }
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    getConcessionStocks: function(cl_id) {
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage
      };
      PosFnbService.GetAllConcessionStocks({ cl_id }, payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.concession_stocks = data.Records;
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    goToRoute: function(path, { cstock_id }) {
      this.$router.push({
        path: path,
        query: {
          cstock_id: cstock_id
        }
      });
    },
    /* eslint-disable */

    viewType: function(viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    }
    // onClickEdit: function(){
    //   this.$router.push({ path: 'master/editaggregators' })
    // }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/ConcessionStockComponents/concessionStock.vue